import TaskForm, { TaskField } from "../TaskForm";
import ParcelService from "../../../services/parcelService";
import { UsageTask } from "../../../interfaces/UsageTask";

interface CreateEntryFormProps {
    onSave: (newEntry: UsageTask) => void;
    parcelId: number;
    cycleId: number;
    isNew: boolean;
    task?: UsageTask;
    readOnly?: boolean;
}

export default function UsageCreateForm(props: CreateEntryFormProps) {
    const parcelService = new ParcelService();

    const fields: TaskField[] = [
        { name: "dateFrom", label: "Datum von", type: "date", required: true },
        { name: "dateTo", label: "Datum bis", type: "date", required: true },
        { name: "quantity", label: "Ertrag (pro/ha)", type: "number", required: true },
        { name: "note", label: "Notizen", type: "textarea" }
    ] as const;

    const defaultState: UsageTask = {
        id: "",
        dateFrom: new Date(),
        dateTo: new Date(new Date().setDate(new Date().getDate() + 2)),
        quantity: 0,
        note: ""
    };

    return (
        <TaskForm<UsageTask>
            title="Nutzung"
            fields={fields}
            isNew={props.isNew}
            task={props.task}
            defaultState={defaultState}
            onSubmit={async (data) => {
                if (props.isNew) {
                    await parcelService.createUsageTask(props.parcelId, props.cycleId, data);
                } else {
                    await parcelService.updateUsageTask(props.parcelId, props.cycleId, Number(data.id), data);
                }
                await props.onSave(data);
            }}
            readOnly={props.readOnly}
        />
    );
}
